import React, { useState } from 'react';

import { Typography, Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

import karen from '../assets/karen.svg';
import erika from '../assets/erika.svg';
import patti from '../assets/patti.svg';
import venus from '../assets/venus.svg';
import pauseButton from '../assets/pauseAudio.svg';
import playButton3 from '../assets/playAudio3.svg';
import karenAudio from '../assets/audio/karen_intv_070221_mixdown_0509-0551.wav';
import erikaAudio from '../assets/audio/erika_stallings_070121_mixdown_0517-0605.wav';
import pattiAudio from '../assets/audio/patti_murillo_INTV_070621_mixdown_0821-0856.wav';
import venusAudio from '../assets/audio/venus_gines_07022021_mixdown_0823-0914.wav';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: ' 0 3.4rem',
    marginTop: '4rem',
    overflowX: 'auto',
    flexWrap: 'nowrap',
    maxWidth: '1576px',
    [theme.breakpoints.down('sm')]: {
      padding: '1.5rem'
    }
  },

  lady: {
    padding: '2.125rem',
    minWidth: '19.4rem',
    [theme.breakpoints.down('sm')]: {
      padding: '1.5rem'
    }
  },
  textCont: {
    marginTop: '2.9rem'
  },
  imgCont: {
    height: '14.9rem',
    width: 'auto'
  },
  ladyDescrip: {
    height: '4.5rem',
    marginTop: '1rem'
  },
  button: {
    height: '47px',
    '&:hover': {
      transform: 'scale(1.1,1.1)'
    }
  },
  button1: {
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none'
    }
  }
}));

const nameToAudio = {
  karen: new Audio(karenAudio),
  erika: new Audio(erikaAudio),
  patti: new Audio(pattiAudio),
  venus: new Audio(venusAudio)
};

const MainAudio = () => {
  const classes = useStyles();
  const [isPlaying, setIsPlaying] = useState(false);
  const [personPlaying, setPersonPlaying] = useState('');
  const { ref, inView } = useInView({ triggerOnce: 'true' });

  const audioClickHandler = (name) => {
    if (isPlaying) {
      nameToAudio[personPlaying].pause();
      setIsPlaying(false);
      if (personPlaying !== name) {
        nameToAudio[name].play();
        setIsPlaying(true);
      }
    } else {
      nameToAudio[name].play();
      setIsPlaying(true);
    }
  };

  const renderer = (
    <Grid container className={classes.container}>
      {/* ------------------------------------------------------------------------ karen */}
      <Grid
        container
        direction="column"
        alignItems="center"
        className={classes.lady}
        style={{ borderRight: '2px solid black' }}
      >
        <Grid container justifyContent="center" className={classes.imgCont}>
          <Button
            disableRipple
            disableFocusRipple
            classes={{ root: classes.button1 }}
            style={{ position: 'relative', bottom: '-220px' }}
            onClick={() => {
              audioClickHandler('karen');
              setPersonPlaying('karen');
            }}
          >
            <img
              src={isPlaying && personPlaying === 'karen' ? pauseButton : playButton3}
              alt="oval button with play"
              className={classes.button}
            />
          </Button>
          <motion.img
            initial={{ y: '50px' }}
            animate={{ y: 0, transition: { delay: 0.2, duration: 1, ease: 'easeInOut' } }}
            src={karen}
            alt="illustration of woman"
            style={{ zIndex: -2 }}
          />
        </Grid>
        <Grid container direction="column" className={classes.textCont}>
          <Grid item className={classes.ladyDescrip}>
            <Typography variant="h6">Karen Eubanks Jackson</Typography>
            <Typography variant="body2">
              Founder & CEO,{' '}
              <a
                href="https://www.sistersnetworkinc.org/index.html"
                target="_blank"
                rel="sponsored"
              >
                {' '}
                Sisters Network
              </a>
            </Typography>
          </Grid>
          <Typography varaint="body2" style={{ marginTop: '1.5rem' }}>
            Karen is a four-time breast cancer survivor. Her first diagnosis was in 1993 and her
            most recent in 2020. During her first brush with cancer, she felt like she was unable to
            find the support or information she needed to deal with her diagnosis, so she founded
            Sisters Network, the only national African American breast cancer survivorship
            organization that provides standardized educational outreach programs, survivor and
            family support, and financial assistance through its network of affiliate chapters.
            Today, she is recognized as a leader in the Black breast cancer awareness movement.
          </Typography>
        </Grid>
      </Grid>
      {/* ------------------------------------------------------------------------ erika */}
      <Grid
        container
        direction="column"
        className={classes.lady}
        style={{ borderRight: '2px solid black' }}
      >
        <Grid container justifyContent="center" className={classes.imgCont}>
          <Button
            disableRipple
            disableFocusRipple
            classes={{ root: classes.button1 }}
            style={{ position: 'relative', bottom: '-220px' }}
            onClick={() => {
              audioClickHandler('erika');
              setPersonPlaying('erika');
              // pauseOtherAudio('erika');
            }}
          >
            <img
              src={isPlaying && personPlaying === 'erika' ? pauseButton : playButton3}
              alt="oval button with play"
              className={classes.button}
            />
          </Button>
          <motion.img
            initial={{ y: '50px' }}
            animate={{ y: 0, transition: { delay: 0.6, duration: 1, ease: 'easeInOut' } }}
            src={erika}
            alt="illustration of woman"
          />
        </Grid>
        <Grid container direction="column" className={classes.textCont}>
          <Grid item className={classes.ladyDescrip}>
            <Typography variant="h6">Erika Stallings</Typography>
            <Typography variant="body2">Music Industry Attorney & Health Advocate</Typography>
          </Grid>
          <Typography varaint="body2" style={{ marginTop: '1.5rem' }}>
            As the daughter of a cancer survivor Erika knew she was at high-risk for the disease. In
            2014, at the age of 28, she underwent genetic testing and learned that she had inherited
            a BRCA2 mutation, a hereditary mutation that significantly elevates the risk of
            developing breast and ovarian cancer. Because of this, later that year, she chose to
            undergo a preventative mastectomy.
          </Typography>
        </Grid>
      </Grid>
      {/* ------------------------------------------------------------------------  patti*/}
      <Grid
        container
        direction="column"
        className={classes.lady}
        style={{ borderRight: '2px solid black' }}
      >
        <Grid container justifyContent="center" className={classes.imgCont}>
          <Button
            disableRipple
            disableFocusRipple
            classes={{ root: classes.button1 }}
            style={{ position: 'relative', bottom: '-220px' }}
            onClick={() => {
              audioClickHandler('patti');
              setPersonPlaying('patti');
              // pauseOtherAudio('patti');
            }}
          >
            <img
              src={isPlaying && personPlaying === 'patti' ? pauseButton : playButton3}
              alt="oval button with play"
              className={classes.button}
            />
          </Button>
          <motion.img
            initial={{ y: '50px' }}
            animate={{ y: 0, transition: { delay: 1, duration: 1, ease: 'easeInOut' } }}
            src={patti}
            alt="illustration of woman"
          />
        </Grid>
        <Grid container direction="column" className={classes.textCont}>
          <Grid item className={classes.ladyDescrip}>
            <Typography variant="h6">Patti Murillo-Casa</Typography>
            <Typography variant="body2">
              Retired Police Officer & Women’s Health Educator
            </Typography>
          </Grid>
          <Typography varaint="body2" style={{ marginTop: '1.5rem' }}>
            Patti was 48 years old– visiting her gynecologist for the first time in three years–
            when she first learned what stage 2b cervical cancer was, and that the intermittent
            bleeding she had been experiencing was a symptom of it. The size of the tumor her
            doctors discovered disqualified her from a hysterectomy, and she instead went through
            seven rounds of chemotherapy, 35 rounds of radiation, and two rounds of internal
            radiation before eventually entering remission.
          </Typography>
        </Grid>
      </Grid>
      {/* ------------------------------------------------------------------------  venus*/}
      <Grid container direction="column" className={classes.lady}>
        <Grid container justifyContent="center" className={classes.imgCont}>
          <Button
            disableRipple
            disableFocusRipple
            classes={{ root: classes.button1 }}
            style={{ position: 'relative', bottom: '-220px' }}
            onClick={() => {
              audioClickHandler('venus');
              setPersonPlaying('venus');
              // pauseOtherAudio('venus');
            }}
          >
            <img
              src={isPlaying && personPlaying === 'venus' ? pauseButton : playButton3}
              alt="oval button with play"
              className={classes.button}
            />
          </Button>
          <motion.img
            initial={{ y: '50px' }}
            animate={{ y: 0, transition: { delay: 1.4, duration: 1, ease: 'easeInOut' } }}
            src={venus}
            alt="illustration of woman"
          />
        </Grid>
        <Grid container direction="column" className={classes.textCont}>
          <Grid item className={classes.ladyDescrip}>
            <Typography variant="h6">Venus Ginés</Typography>
            <Typography variant="body2">
              Founder & President,
              <a href="https://www.diadelamujerlatina.org/" target="_blank" rel="sponsored">
                {' '}
                Día de la Mujer Latina
              </a>
            </Typography>
          </Grid>
          <Typography varaint="body2" style={{ marginTop: '1.5rem' }}>
            Venus never liked doctors: her mother, a victim of forced sterilization, taught her not
            to trust them. It wasn’t until an emergency room visit at age 41, when a doctor
            recommended that she have a breast exam, that she discovered she had cancer. Later,
            after learning her sister was experiencing irregular vaginal bleeding, Venus pushed her
            to get it checked out too. Venus’ sister passed away nine months after she was diagnosed
            with cervical cancer. Today, inspired by these experiences, Venus runs Día de la Mujer
            Latina, an organization focused on health education and preventive care interventions
            for the Hispanic community.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );

  return (
    <Grid container direction="column" alignItems="center" className={classes.wrapper} ref={ref}>
      {inView ? renderer : null}
    </Grid>
  );
};

export default MainAudio;
